import React from 'react';
import { Transition } from 'react-transition-group';
import anime from 'animejs';
import { cloneDeep } from 'lodash-es';

class Anime extends React.Component {
  static defaultProps = {
    appear: true,
    skipAnimate: false,
    onEntering: () => {},
    onExiting: () => {},
  };

  target = null;

  onEntering = (node, isAppearing) => {
    this.props.onEntering(node, isAppearing);
    this.animate();

    if (this.props.skipAnimate) {
      this.anime.seek(this.props.animation.duration);
    }
  };

  onExiting = node => {
    const { animation, animationOut, skipAnimate } = this.props;

    this.props.onExiting(node);

    if (animationOut) {
      this.animate({
        ...this.reverse(animation),
        ...animationOut,
      });

      return;
    }

    this.animate(this.reverse(animation));

    if (skipAnimate) {
      this.anime.seek(animation.duration);
    }
  };

  endListener = (node, done) => {
    if (!this.anime) return;
    this.anime.finished.then(done);
  };

  animate(anim = this.props.animation) {
    if (this.anime) this.anime.pause();

    this.anime = anime({
      ...anim,
      targets: this.target,
    });
  }

  reverse = anim => {
    const animation = cloneDeep(anim);

    Object.keys(animation).forEach(key => {
      const prop = animation[key];

      if (Array.isArray(prop)) {
        prop.reverse();
      }
    });

    return animation;
  };

  render() {
    const {
      component: Component = 'div',
      className,
      style,
      children,
      animation,
      ...props
    } = this.props;

    return (
      <Transition
        {...props}
        onEntering={this.onEntering}
        onExiting={this.onExiting}
        addEndListener={this.endListener}
        timeout={animation.duration}
      >
        {() => (
          <Component
            className={className}
            style={style}
            ref={ref => {
              this.target = ref;
            }}
          >
            {children}
          </Component>
        )}
      </Transition>
    );
  }
}

export default Anime;
